import { Routes } from '../../enums/Routes';
import { buildRoute } from '../../utils/routeBuilder';

/**
 * The team leader, HR and the safety representative open the same survey pages, each from
 * their own part of the menu. Links between the pages stay in the part the user came from.
 */
export type SurveySection = 'team' | 'hr' | 'safetyRep';

const ROUTES: Record<SurveySection, { survey: Routes; report: Routes; inspectionReport: Routes }> = {
  team: {
    survey: Routes.DashboardWorkEnvironmentSurvey,
    report: Routes.WorkEnvironmentReport,
    inspectionReport: Routes.WorkEnvironmentInspectionReport,
  },
  hr: {
    survey: Routes.HRWorkEnvironmentSurveyDetailFullPath,
    report: Routes.HRWorkEnvironmentReport,
    inspectionReport: Routes.HRWorkEnvironmentInspectionReport,
  },
  safetyRep: {
    survey: Routes.SafetyRepSurvey,
    report: Routes.SafetyRepReport,
    inspectionReport: Routes.SafetyRepInspectionReport,
  },
};

export const sectionOf = (pathname: string): SurveySection =>
  pathname.startsWith('/hr/')
    ? 'hr'
    : pathname.startsWith(Routes.SafetyRepOverview)
      ? 'safetyRep'
      : 'team';

export const surveyPath = (section: SurveySection, surveyId: number) =>
  buildRoute(ROUTES[section].survey, { surveyId });

export const reportPath = (section: SurveySection, surveyId: number) =>
  buildRoute(ROUTES[section].report, { surveyId });

export const inspectionReportPath = (section: SurveySection, surveyId: number) =>
  buildRoute(ROUTES[section].inspectionReport, { surveyId });

/** «?omrade=VIOLENCE» opens the plan step at the area, «&beslutning=1» at its decision */
export const AREA_PARAM = 'omrade';
export const DECISION_PARAM = 'beslutning';

/** Where a plan or a decision for the area is made: step 7 of the survey, at the area */
export const planAreaPath = (section: SurveySection, surveyId: number, areaKey: string, decision = false) =>
  `${surveyPath(section, surveyId)}?${new URLSearchParams({
    [AREA_PARAM]: areaKey,
    ...(decision ? { [DECISION_PARAM]: '1' } : {}),
  }).toString()}`;
